import type { CommerceEventBaseData } from "@jti/tracker";

const fallbackValue = "N/A";

const defaultBrand = "ploom";

// `process` is undefined in browser-only runtimes such as Storybook browser tests.
const resolveItemBrand = (): string =>
  (typeof process !== "undefined" ? process.env?.NEXT_PUBLIC_BRAND : undefined) || defaultBrand;

type ViewItemListEventItemInput = {
  sku?: string;
  name?: string;
  price?: number;
  discount?: number;
  category?: string;
};

export const viewItemListEventDataFactory = (
  items: ViewItemListEventItemInput[],
  currency: string
): Omit<CommerceEventBaseData, "value"> => ({
  currency: currency || fallbackValue,
  ecommerce: {
    items: items.map((item, index) => ({
      item_id: item.sku || fallbackValue,
      currency: currency || fallbackValue,
      price: item.price ?? fallbackValue,
      discount: item.discount ?? fallbackValue,
      quantity: 1,
      index,
      item_brand: resolveItemBrand(),
      item_category: item.category || fallbackValue,
      item_category2: fallbackValue,
      item_name: item.name || fallbackValue,
      item_color: fallbackValue,
      item_flavor: fallbackValue,
      item_strength: fallbackValue,
      item_coupon: fallbackValue,
      item_coupon_type: fallbackValue,
      item_list_id: fallbackValue,
      item_list_name: item.category || fallbackValue,
      item_rewards: fallbackValue,
      item_sku: item.sku || fallbackValue,
      purchase_type: fallbackValue,
      carton_format: fallbackValue,
      carton_quantity: fallbackValue,
    })),
  },
});
